import { pageBreadcrumbStyles as styles } from "@insite/content-library/Components/PageBreadcrumbs";
import { Slash } from "@insite/mobius/Breadcrumbs";
import { StyledTypography } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.breadcrumbs = {
    css: css`
        padding: 17px 30px 20px;

        ${TypographyStyle} {
            font-size: 14px;
            font-weight: 700;
            line-height: 18px;
        }

        ${StyledTypography} {
            font-weight: 400;
        }

        ${Slash} {
            margin: 0 5px;
            font-weight: 600;
        }

        ${mediaQueriesBP.maxMD} {
            padding: 11px 20px 7px;
        }

        @media screen and (min-width: 1220px) {
            padding: 17px 20px 20px;
        }
    `,
};
